import React from "react";
import { Button, Link } from "arag-ui-lib";
import { LEFT, PRIMARY, TERTIARY } from "./constants";



const ColumnButtons = (props) => {

    const {
        buttonLabel,
        submitHandler,
        linkLabel,
        linkTestId,
        discardHandler,
        buttonTestId,
        isButtonDisabled=false,
        isLinkDisabled=false,
    } = props;

    return (
        <>
            <Button
                onClick={submitHandler}
                label={buttonLabel}
                variant={PRIMARY}
                arrowDirection={LEFT}
                buttonTestId={buttonTestId}
                disabled={isButtonDisabled}
            />
            <Link
                onClick={discardHandler}
                label={linkLabel}
                variant={TERTIARY}
                arrowDirection={LEFT}
                linkTestId={linkTestId}
                disabled={isLinkDisabled}
            />
        </>
    );
};

export default ColumnButtons;